import script from "./CourtScheduleSetup.vue?vue&type=script&setup=true&lang=js"
export * from "./CourtScheduleSetup.vue?vue&type=script&setup=true&lang=js"

import "./CourtScheduleSetup.vue?vue&type=style&index=0&id=ed8d6afe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ed8d6afe"]])

export default __exports__